var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "invoice-preview-wrapper" },
    [
      _c(
        "div",
        { staticClass: "d-flex justify-content-center mb-1" },
        [
          _vm.loadingInvoice
            ? _c("b-spinner", {
                staticStyle: { width: "3rem", height: "3rem" },
                attrs: { variant: "success", label: "Spinning", block: "" },
              })
            : _vm._e(),
        ],
        1
      ),
      !_vm.loadingInvoice
        ? _c(
            "b-row",
            { staticClass: "invoice-preview" },
            [
              _c(
                "b-col",
                { attrs: { cols: "12", xl: "9", md: "8" } },
                [
                  _c(
                    "b-card",
                    {
                      staticClass: "invoice-preview-card px-2",
                      attrs: { "no-body": "", id: "invoice-preview-card" },
                    },
                    [
                      _c("b-card-body", {}, [
                        _c(
                          "div",
                          { staticClass: "row align-items-center mb-2" },
                          [
                            _c(
                              "div",
                              { staticClass: "col-md-1 col-1" },
                              [_c("Logo")],
                              1
                            ),
                            _c("div", { staticClass: "col-md-9 col-9" }, [
                              _c("div", {}, [_c("CompanyName")], 1),
                              _c("div", {}, [_c("Address")], 1),
                            ]),
                          ]
                        ),
                        _c("div", { staticClass: "row" }, [
                          this.vat
                            ? _c("div", { staticClass: "col-12" }, [
                                _c("h4", { staticClass: "mb-1 text-center" }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        this.vat && !this.hideVAT ? "VAT " : ""
                                      ) +
                                      " INVOICE "
                                  ),
                                ]),
                              ])
                            : _vm._e(),
                          _c("div", { staticClass: "col-6 xl-6" }, [
                            _c(
                              "div",
                              [
                                _c("h4", { staticClass: "mb-1" }, [
                                  _vm._v("Customer"),
                                ]),
                                _c("ClientAddress", {
                                  attrs: { client: _vm.whenSelected },
                                }),
                              ],
                              1
                            ),
                          ]),
                          _c("div", { staticClass: "col-6 text-right" }, [
                            _c("h4", [
                              _vm._v(" Invoice No "),
                              _c("span", { staticClass: "invoice-number" }, [
                                _vm._v("#" + _vm._s(_vm.invoiceId.invoiceNo)),
                              ]),
                            ]),
                            _c("div", { staticClass: "text-right" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "row invoice-date-wrapper justify-content-end",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-md-7 col-7 d-flex justify-content-end",
                                    },
                                    [
                                      _c("p", { staticClass: "title" }, [
                                        _vm._v("Issue Date:"),
                                      ]),
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-md-5 col-5 d-flex justify-content-end",
                                    },
                                    [
                                      _c("flat-pickr", {
                                        staticClass:
                                          "form-control invoice-edit-input",
                                        attrs: { disabled: "" },
                                        model: {
                                          value: _vm.invoiceId.createdOn,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.invoiceId,
                                              "createdOn",
                                              $$v
                                            )
                                          },
                                          expression: "invoiceId.createdOn",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                              _c(
                                "div",
                                { staticClass: "row invoice-date-wrapper" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-md-7 col-7 d-flex justify-content-end",
                                    },
                                    [
                                      _c("p", { staticClass: "title" }, [
                                        _vm._v("Due Date:"),
                                      ]),
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-md-5 col-5 d-flex justify-content-end ",
                                    },
                                    [
                                      _c("flat-pickr", {
                                        staticClass:
                                          "form-control invoice-edit-input",
                                        attrs: { disabled: "" },
                                        model: {
                                          value: _vm.invoiceId.dueDate,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.invoiceId,
                                              "dueDate",
                                              $$v
                                            )
                                          },
                                          expression: "invoiceId.dueDate",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                              this.vat && !this.hideVAT
                                ? _c(
                                    "div",
                                    { staticClass: "row invoice-date-wrapper" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-md-7 col-7  justify-content-md-end",
                                        },
                                        [
                                          _c("p", { staticClass: "title" }, [
                                            _vm._v("VAT Number:"),
                                          ]),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-md-5 col-5  justify-content-md-end",
                                        },
                                        [
                                          _c(
                                            "p",
                                            { staticClass: "invoice-date" },
                                            [
                                              _vm._v(
                                                " " + _vm._s(this.vat) + " "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              this.vat && !this.hideVAT
                                ? _c(
                                    "div",
                                    { staticClass: "row invoice-date-wrapper" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-md-7 col-7  justify-content-md-end",
                                        },
                                        [
                                          _c(
                                            "p",
                                            {
                                              staticClass: "invoice-date-title",
                                            },
                                            [_vm._v("BRN Number:")]
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-md-5 col-5  justify-content-md-end",
                                        },
                                        [
                                          _c(
                                            "p",
                                            { staticClass: "invoice-date" },
                                            [
                                              _vm._v(
                                                " " + _vm._s(this.brn) + " "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.isFieldChosen("SalesRep")
                                ? _c(
                                    "div",
                                    { staticClass: "row invoice-date-wrapper" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-md-6 col-6 d-flex justify-content-md-end flex-grow-1",
                                        },
                                        [
                                          _c(
                                            "p",
                                            {
                                              staticClass: "invoice-date-title",
                                            },
                                            [_vm._v("Salesperson:")]
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "col-md-6 col-6" },
                                        [
                                          _c(
                                            "p",
                                            { staticClass: "invoice-date" },
                                            [
                                              _vm._v(
                                                " " + _vm._s(this.genSP) + " "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.invoiceId.currency &&
                              _vm.invoiceId.currency != "MUR"
                                ? _c(
                                    "div",
                                    { staticClass: "row invoice-date-wrapper" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-md-6 col-6 d-flex justify-content-md-end flex-grow-1",
                                        },
                                        [
                                          _c(
                                            "p",
                                            {
                                              staticClass: "invoice-date-title",
                                            },
                                            [
                                              _vm._v(
                                                " Rate (" +
                                                  _vm._s(
                                                    this.invoiceId.currency
                                                  ) +
                                                  "): "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "col-md-6 col-6" },
                                        [
                                          _c(
                                            "p",
                                            { staticClass: "invoice-date" },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(_vm.invoiceId.rate) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]),
                          ]),
                        ]),
                      ]),
                      _c("b-card-body", [
                        _c(
                          "div",
                          { staticClass: "mt-3" },
                          [
                            _c("b-table", {
                              attrs: {
                                bordered: "",
                                responsive: "",
                                items: _vm.invoiceId.invoiceItem,
                                fields: _vm.dynamicFields,
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "cell(productImg)",
                                    fn: function (data) {
                                      return [
                                        data.item.itemId
                                          ? [
                                              _c("img", {
                                                staticStyle: {
                                                  width: "75px",
                                                  height: "75px",
                                                  "object-fit": "cover",
                                                },
                                                attrs: {
                                                  src:
                                                    _vm.baseUrl +
                                                    "selfservices/getproductimage?ProductID=" +
                                                    data.item.itemId,
                                                  alt: "Product Image",
                                                },
                                                on: {
                                                  error: function ($event) {
                                                    return _vm.showNoImage(
                                                      $event
                                                    )
                                                  },
                                                },
                                              }),
                                            ]
                                          : [_c("span", [_vm._v("-")])],
                                      ]
                                    },
                                  },
                                  {
                                    key: "cell(cost)",
                                    fn: function (data) {
                                      return [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.currencySymbol) +
                                            " " +
                                            _vm._s(
                                              (
                                                data.item.cost *
                                                  data.item.quantity -
                                                (data.item.discount === null
                                                  ? 0
                                                  : data.item.discount)
                                              ).toFixed(2)
                                            ) +
                                            " "
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "cell(discount)",
                                    fn: function (data) {
                                      return [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.currencySymbol) +
                                            " " +
                                            _vm._s(
                                              (data.item.discount === null
                                                ? 0
                                                : data.item.discount
                                              ).toFixed(2)
                                            ) +
                                            " "
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                111171352
                              ),
                            }),
                          ],
                          1
                        ),
                      ]),
                      _c(
                        "b-card-body",
                        {},
                        [
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass: "mt-md-0 mt-3",
                                  attrs: { cols: "12", md: "6" },
                                },
                                [
                                  _vm.isFieldChosen("Notes")
                                    ? _c(
                                        "span",
                                        { staticClass: "font-weight-bold" },
                                        [_vm._v("Note: ")]
                                      )
                                    : _vm._e(),
                                  _vm.isFieldChosen("Notes")
                                    ? _c("span", [
                                        _vm._v(_vm._s(_vm.invoiceId.notes)),
                                      ])
                                    : _vm._e(),
                                ]
                              ),
                              _c(
                                "b-col",
                                {
                                  staticClass:
                                    "mt-md-6 d-flex justify-content-end",
                                  attrs: { cols: "12", md: "6" },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "invoice-total-wrapper" },
                                    [
                                      _vm.invoiceId.discount > 0
                                        ? _c(
                                            "div",
                                            {
                                              staticClass: "invoice-total-item",
                                            },
                                            [
                                              _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "invoice-total-title",
                                                },
                                                [_vm._v("Discount:")]
                                              ),
                                              _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "invoice-total-amount",
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.currencySymbol
                                                      ) +
                                                      " " +
                                                      _vm._s(
                                                        _vm.invoiceId
                                                          .discount == null
                                                          ? 0.0
                                                          : _vm.invoiceId.discount.toFixed(
                                                              2
                                                            )
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _c(
                                        "div",
                                        { staticClass: "invoice-total-item" },
                                        [
                                          _c(
                                            "p",
                                            {
                                              staticClass:
                                                "invoice-total-title",
                                            },
                                            [_vm._v("Subtotal:")]
                                          ),
                                          _c(
                                            "p",
                                            {
                                              staticClass:
                                                "invoice-total-amount",
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(_vm.currencySymbol) +
                                                  " " +
                                                  _vm._s(
                                                    parseFloat(
                                                      _vm.invoiceId.subTotal
                                                    ).toFixed(2)
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      this.vat && !this.hideVAT
                                        ? _c(
                                            "div",
                                            {
                                              staticClass: "invoice-total-item",
                                            },
                                            [
                                              _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "invoice-total-title",
                                                },
                                                [_vm._v("VAT:")]
                                              ),
                                              _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "invoice-total-amount",
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.currencySymbol
                                                      ) +
                                                      " " +
                                                      _vm._s(
                                                        parseFloat(
                                                          _vm.invoiceId.tax
                                                        ).toFixed(2)
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _c("hr", { staticClass: "my-50" }),
                                      _c(
                                        "div",
                                        { staticClass: "invoice-total-item" },
                                        [
                                          _c(
                                            "p",
                                            {
                                              staticClass:
                                                "invoice-total-title",
                                            },
                                            [_vm._v("Total:")]
                                          ),
                                          _c(
                                            "p",
                                            {
                                              staticClass:
                                                "invoice-total-amount",
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(_vm.currencySymbol) +
                                                  " " +
                                                  _vm._s(_vm.getTotal) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm.payments.totalPaid > 0
                                        ? _c(
                                            "div",
                                            {
                                              staticClass: "invoice-total-item",
                                            },
                                            [
                                              _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "invoice-total-title",
                                                },
                                                [_vm._v("Total Paid:")]
                                              ),
                                              _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "invoice-total-amount",
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.currencySymbol
                                                      ) +
                                                      " " +
                                                      _vm._s(
                                                        _vm.payments.totalPaid.toFixed(
                                                          2
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm.payments.totalPaid > 0
                                        ? _c(
                                            "div",
                                            {
                                              staticClass: "invoice-total-item",
                                            },
                                            [
                                              _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "invoice-total-title",
                                                },
                                                [_vm._v("Balance:")]
                                              ),
                                              _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "invoice-total-amount",
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.currencySymbol
                                                      ) +
                                                      " " +
                                                      _vm._s(
                                                        _vm.payments.balance.toFixed(
                                                          2
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm.isFieldChosen("PaymentTerms") &&
                      _vm.payments.payments &&
                      _vm.payments.payments.length > 0
                        ? _c(
                            "b-card",
                            {
                              staticClass: "no-margin-body",
                              attrs: { title: "Payments" },
                            },
                            [
                              _c(
                                "b-card-body",
                                [
                                  _vm.payments.payments &&
                                  _vm.payments.payments.length > 0
                                    ? _c("b-table", {
                                        staticClass: "table-payment",
                                        attrs: {
                                          responsive: "",
                                          items: _vm.payments.payments,
                                          fields: [
                                            {
                                              key: "settlementDate",
                                              label: "Settlement Date",
                                            },
                                            {
                                              key: "reference",
                                              label: "Reference",
                                            },
                                            {
                                              key: "amountPaid",
                                              label: "Amount Paid",
                                            },
                                          ],
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "cell(Delete)",
                                              fn: function (data) {
                                                return [
                                                  _c(
                                                    "b-button",
                                                    {
                                                      attrs: {
                                                        variant:
                                                          "outline-danger",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.deletePayment(
                                                            data.id
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c("feather-icon", {
                                                        attrs: {
                                                          icon: "DeleteIcon",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                            },
                                            {
                                              key: "cell(settlementDate)",
                                              fn: function (data) {
                                                return [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.beautifyDate(
                                                          data.item
                                                            .settlementDate
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              },
                                            },
                                            {
                                              key: "cell(amountPaid)",
                                              fn: function (data) {
                                                return [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.currencySymbol
                                                      ) +
                                                      " " +
                                                      _vm._s(
                                                        data.item.amountPaid.toFixed(
                                                          2
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          3574589125
                                        ),
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.deliverynotes.length > 0
                        ? _c(
                            "b-card",
                            { attrs: { title: "Delivery Notes" } },
                            [
                              _c("b-table", {
                                staticClass: "table-delivery",
                                attrs: {
                                  responsive: "",
                                  bordered: "",
                                  items: _vm.deliverynotes,
                                  fields: [
                                    { key: "product", label: "Product" },
                                    {
                                      key: "deliveryDate",
                                      label: "Delivery Date",
                                      formatter: _vm.beautifyDate,
                                    },
                                    { key: "quantity", label: "quantity" },
                                    { key: "note", label: "Note" },
                                    { key: "comment", label: "Comment" },
                                    { key: "status", label: "Status" },
                                    { key: "signature", label: "Signature" },
                                  ],
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "cell(productImg)",
                                      fn: function (data) {
                                        return [
                                          _c("b-avatar", {
                                            attrs: { src: data.value },
                                          }),
                                        ]
                                      },
                                    },
                                    {
                                      key: "cell(product)",
                                      fn: function (data) {
                                        return [
                                          _c("span", [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.getProductName(
                                                    data.item.itemId
                                                  )
                                                )
                                            ),
                                          ]),
                                        ]
                                      },
                                    },
                                    {
                                      key: "cell(signature)",
                                      fn: function (data) {
                                        return [
                                          data.item.signature != null
                                            ? _c(
                                                "b-button",
                                                {
                                                  directives: [
                                                    {
                                                      name: "ripple",
                                                      rawName: "v-ripple.400",
                                                      value:
                                                        "rgba(255, 255, 255, 0.15)",
                                                      expression:
                                                        "'rgba(255, 255, 255, 0.15)'",
                                                      modifiers: { 400: true },
                                                    },
                                                  ],
                                                  attrs: { variant: "primary" },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.viewSignature(
                                                        data.item.id
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v(" Signature ")]
                                              )
                                            : _vm._e(),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  893524227
                                ),
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-col",
                {
                  staticClass: "invoice-actions",
                  attrs: { cols: "12", md: "4", xl: "3" },
                },
                [
                  _c(
                    "b-card",
                    [
                      _c(
                        "b-button",
                        {
                          directives: [
                            {
                              name: "ripple",
                              rawName: "v-ripple.400",
                              value: "rgba(186, 191, 199, 0.15)",
                              expression: "'rgba(186, 191, 199, 0.15)'",
                              modifiers: { 400: true },
                            },
                          ],
                          staticClass: "mb-75",
                          attrs: { variant: "outline-secondary", block: "" },
                          on: { click: _vm.printInvoice },
                        },
                        [_vm._v(" Print / Download ")]
                      ),
                      _vm.payments.payments.length === 0 &&
                      _vm.invoiceId.status < 2
                        ? _c(
                            "b-button",
                            {
                              directives: [
                                {
                                  name: "ripple",
                                  rawName: "v-ripple.400",
                                  value: "rgba(186, 191, 199, 0.15)",
                                  expression: "'rgba(186, 191, 199, 0.15)'",
                                  modifiers: { 400: true },
                                },
                              ],
                              staticClass: "mb-75",
                              attrs: { variant: "primary", block: "" },
                              on: {
                                click: function ($event) {
                                  return _vm.returnInvoice()
                                },
                              },
                            },
                            [_vm._v(" Return Invoice ")]
                          )
                        : _vm._e(),
                      _vm.payments.balance != 0 && _vm.invoiceId.status !== 3
                        ? _c(
                            "b-button",
                            {
                              directives: [
                                {
                                  name: "ripple",
                                  rawName: "v-ripple.400",
                                  value: "rgba(186, 191, 199, 0.15)",
                                  expression: "'rgba(186, 191, 199, 0.15)'",
                                  modifiers: { 400: true },
                                },
                                {
                                  name: "b-modal",
                                  rawName: "v-b-modal.modal-payment",
                                  modifiers: { "modal-payment": true },
                                },
                              ],
                              staticClass: "mb-75",
                              attrs: { variant: "primary", block: "" },
                            },
                            [_vm._v(" Add Payment ")]
                          )
                        : _vm._e(),
                      _c(
                        "b-button",
                        {
                          directives: [
                            {
                              name: "ripple",
                              rawName: "v-ripple.400",
                              value: "rgba(186, 191, 199, 0.15)",
                              expression: "'rgba(186, 191, 199, 0.15)'",
                              modifiers: { 400: true },
                            },
                          ],
                          staticClass: "mb-75",
                          attrs: { variant: "primary", block: "" },
                          on: {
                            click: function ($event) {
                              return _vm.handleInvoiceDocBtn(_vm.invoiceId.id)
                            },
                          },
                        },
                        [_vm._v(" Documents ")]
                      ),
                      _c(
                        "b-modal",
                        {
                          ref: "modal-view-invoice-document",
                          attrs: {
                            id: "modal-view-invoice-document",
                            "ok-only": "",
                            "ok-title": "View",
                            centered: "",
                            size: "lg",
                            title: "View Documents",
                            "hide-footer": true,
                          },
                        },
                        [
                          _c("DocumentUpload", {
                            attrs: { documentDetails: _vm.documentDetails },
                            on: {
                              deleteFile: _vm.deleteFile,
                              downloadFile: _vm.downloadFile,
                              uploadFiles: _vm.uploadFiles,
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-modal",
                        {
                          ref: "signatureModalOpen",
                          attrs: {
                            title: "Digital Signature",
                            "hide-footer": "",
                            centered: "",
                          },
                        },
                        [
                          _c("VueSignaturePad", {
                            ref: "signaturePad",
                            staticStyle: {
                              border: "1px solid #ccc",
                              "background-color": "#fff",
                            },
                            attrs: {
                              id: "signature",
                              width: "100%",
                              height: "30vh",
                              options: {
                                onBegin: function () {
                                  _vm.$refs.signaturePad.resizeCanvas()
                                },
                              },
                            },
                          }),
                          _c(
                            "div",
                            { staticClass: "text-center mt-3" },
                            [
                              _c(
                                "b-button",
                                {
                                  staticClass: "mr-1",
                                  attrs: { variant: "success" },
                                  on: { click: _vm.saveSignature },
                                },
                                [_vm._v("Save")]
                              ),
                              _c(
                                "b-button",
                                {
                                  staticClass: "mr-1",
                                  attrs: { variant: "warning" },
                                  on: { click: _vm.undo },
                                },
                                [_vm._v("Undo")]
                              ),
                              _c(
                                "b-button",
                                {
                                  attrs: { variant: "danger" },
                                  on: { click: _vm.clearSignature },
                                },
                                [_vm._v("Clear")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm.productsDLL.length > 0 && _vm.invoiceId.status !== 3
                        ? _c(
                            "b-button",
                            {
                              directives: [
                                {
                                  name: "ripple",
                                  rawName: "v-ripple.400",
                                  value: "rgba(186, 191, 199, 0.15)",
                                  expression: "'rgba(186, 191, 199, 0.15)'",
                                  modifiers: { 400: true },
                                },
                                {
                                  name: "b-modal",
                                  rawName: "v-b-modal.modal-delivery",
                                  modifiers: { "modal-delivery": true },
                                },
                              ],
                              staticClass: "mb-75",
                              attrs: { variant: "primary", block: "" },
                            },
                            [_vm._v(" Schedule Delivery ")]
                          )
                        : _vm._e(),
                      this.invoiceId.rating !== null ||
                      this.invoiceId.rating > 0
                        ? _c(
                            "b-button",
                            {
                              directives: [
                                {
                                  name: "ripple",
                                  rawName: "v-ripple.400",
                                  value: "rgba(186, 191, 199, 0.15)",
                                  expression: "'rgba(186, 191, 199, 0.15)'",
                                  modifiers: { 400: true },
                                },
                                {
                                  name: "b-modal",
                                  rawName: "v-b-modal.modal-rating",
                                  modifiers: { "modal-rating": true },
                                },
                              ],
                              staticClass: "mb-75",
                              attrs: { variant: "primary", block: "" },
                            },
                            [_vm._v(" View Rating ")]
                          )
                        : _vm._e(),
                      this.vat
                        ? _c(
                            "b-button",
                            {
                              directives: [
                                {
                                  name: "ripple",
                                  rawName: "v-ripple.400",
                                  value: "rgba(186, 191, 199, 0.15)",
                                  expression: "'rgba(186, 191, 199, 0.15)'",
                                  modifiers: { 400: true },
                                },
                              ],
                              staticClass: "mb-75",
                              attrs: { variant: "primary", block: "" },
                              on: {
                                click: function ($event) {
                                  _vm.hideVAT = !_vm.hideVAT
                                },
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    this.hideVAT ? "Show VAT" : "Hide VAT"
                                  ) +
                                  " "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm.whenSelected.tel &&
                      _vm.tenant &&
                      _vm.invoiceId.status !== 3
                        ? _c(
                            "b-button",
                            {
                              directives: [
                                {
                                  name: "ripple",
                                  rawName: "v-ripple.400",
                                  value: "rgba(186, 191, 199, 0.15)",
                                  expression: "'rgba(186, 191, 199, 0.15)'",
                                  modifiers: { 400: true },
                                },
                              ],
                              staticClass: "mb-75",
                              attrs: { variant: "info", block: "" },
                              on: { click: _vm.openWhatsApp },
                            },
                            [
                              _c("img", {
                                staticClass: "w-10",
                                attrs: {
                                  src: require("@/assets/images/logo/whatsapp.png"),
                                },
                              }),
                              _vm._v(" Whatsapp "),
                            ]
                          )
                        : _vm._e(),
                      _vm.payments.balance === 0 &&
                      _vm.invoiceId.status !== 2 &&
                      _vm.invoiceId.status !== 3
                        ? _c(
                            "b-button",
                            {
                              directives: [
                                {
                                  name: "ripple",
                                  rawName: "v-ripple.400",
                                  value: "rgba(186, 191, 199, 0.15)",
                                  expression: "'rgba(186, 191, 199, 0.15)'",
                                  modifiers: { 400: true },
                                },
                              ],
                              staticClass: "mb-75",
                              attrs: { variant: "primary", block: "" },
                              on: { click: _vm.CompleteInvoice },
                            },
                            [_vm._v(" Complete ")]
                          )
                        : _vm._e(),
                      _vm.invoiceId.status === 3
                        ? _c(
                            "b-button",
                            {
                              directives: [
                                {
                                  name: "ripple",
                                  rawName: "v-ripple.400",
                                  value: "rgba(186, 191, 199, 0.15)",
                                  expression: "'rgba(186, 191, 199, 0.15)'",
                                  modifiers: { 400: true },
                                },
                              ],
                              staticClass: "mb-75",
                              attrs: { variant: "primary", block: "" },
                              on: { click: _vm.showSignaturePad },
                            },
                            [_vm._v(" Signature ")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "b-modal",
        {
          attrs: {
            id: "modal-delivery",
            centered: "",
            title: "Schedule Delivery",
            "hide-footer": "",
          },
          on: { hide: _vm.clearDelivery },
        },
        [
          _c(
            "b-form",
            {
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _vm.addDelivery($event)
                },
              },
            },
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: "Last Delivery Date",
                            "label-for": "h-Date",
                          },
                        },
                        [
                          _c("b-form-datepicker", {
                            attrs: {
                              id: "h-Date",
                              placeholder: "Choose a date",
                              required: "",
                              min: _vm.minDate,
                              config: _vm.configDue.wrap,
                              local: "en",
                              "initial-date": _vm.currentDate(),
                            },
                            model: {
                              value: _vm.deliveryDate,
                              callback: function ($$v) {
                                _vm.deliveryDate = $$v
                              },
                              expression: "deliveryDate",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "b-form-group",
                        { attrs: { label: "Product", "label-for": "h-Date" } },
                        [
                          _c("b-form-select", {
                            attrs: {
                              id: "h-Date",
                              options: _vm.productsDLL,
                              required: "",
                            },
                            model: {
                              value: _vm.deliveryProduct,
                              callback: function ($$v) {
                                _vm.deliveryProduct = $$v
                              },
                              expression: "deliveryProduct",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: { label: "Comments", "label-for": "d-Amount" },
                        },
                        [
                          _c("b-form-textarea", {
                            attrs: {
                              id: "d-Amount",
                              placeholder: "Comments",
                              required: "",
                            },
                            model: {
                              value: _vm.deliveryNote,
                              callback: function ($$v) {
                                _vm.deliveryNote = $$v
                              },
                              expression: "deliveryNote",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "b-button",
                        { attrs: { variant: "primary", type: "submit" } },
                        [
                          _c("b-icon", { attrs: { icon: "plus-circle" } }),
                          _vm._v(" Schedule Delivery "),
                          _vm.loadingNote ? _c("b-spinner") : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-modal",
        {
          attrs: {
            id: "modal-rating",
            centered: "",
            title: "Invoice Rating",
            "hide-footer": "",
          },
        },
        [
          _c(
            "b-form",
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "b-form-group",
                        { attrs: { label: "Rating", "label-for": "h-rating" } },
                        [
                          _c("vue-star-rating", {
                            attrs: {
                              "star-size": 30,
                              rating: _vm.rating,
                              increment: 0.5,
                              "read-only": true,
                            },
                            model: {
                              value: _vm.invoiceId.rating,
                              callback: function ($$v) {
                                _vm.$set(_vm.invoiceId, "rating", $$v)
                              },
                              expression: "invoiceId.rating",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: "Feedback",
                            "label-for": "d-description",
                          },
                        },
                        [
                          _c("b-form-textarea", {
                            attrs: {
                              id: "d-description",
                              value: _vm.feedbacks
                                ? _vm.feedbacks.description || ""
                                : "",
                              placeholder: "Customer Feedback",
                              disabled: "",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-modal",
        {
          attrs: {
            id: "modal-payment",
            centered: "",
            title: "Add Payment",
            "hide-footer": "",
          },
        },
        [
          _c(
            "b-form",
            {
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _vm.addPayment($event)
                },
              },
            },
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: "Settlement Date",
                            "label-for": "h-Date",
                          },
                        },
                        [
                          _c("b-form-datepicker", {
                            attrs: {
                              id: "datepicker-placeholder",
                              placeholder: "Choose a date",
                              required: "",
                              local: "en",
                              "initial-date": _vm.currentDate(),
                            },
                            model: {
                              value: _vm.paymentDate,
                              callback: function ($$v) {
                                _vm.paymentDate = $$v
                              },
                              expression: "paymentDate",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: "Payment Amount",
                            "label-for": "d-Amount",
                          },
                        },
                        [
                          _c("b-form-input", {
                            attrs: {
                              id: "amount",
                              placeholder: _vm.currencySymbol,
                              type: "number",
                              required: "",
                              min: "0",
                              step: ".01",
                            },
                            model: {
                              value: _vm.paymentAmount,
                              callback: function ($$v) {
                                _vm.paymentAmount = $$v
                              },
                              expression: "paymentAmount",
                            },
                          }),
                          _vm.paymentAmount > _vm.payments.balance
                            ? _c("span", { staticClass: "text-danger" }, [
                                _vm._v(
                                  "Error: Payment amount is greater than payment balance"
                                ),
                              ])
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: "Payment Mode",
                            "label-for": "d-PaymentMode",
                          },
                        },
                        [
                          _c("b-form-select", {
                            attrs: {
                              id: "h-paymentMode",
                              options: _vm.paymentOptions,
                              required: "",
                            },
                            on: { change: _vm.handleModeChange },
                            model: {
                              value: _vm.paymentMode,
                              callback: function ($$v) {
                                _vm.paymentMode = $$v
                              },
                              expression: "paymentMode",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: "Reference",
                            "label-for": "d-Reference",
                          },
                        },
                        [
                          _c("b-form-input", {
                            attrs: { id: "h-Reference" },
                            model: {
                              value: _vm.reference,
                              callback: function ($$v) {
                                _vm.reference = $$v
                              },
                              expression: "reference",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "b-button",
                        {
                          attrs: {
                            variant: "primary",
                            type: "submit",
                            disabled: _vm.loading,
                          },
                        },
                        [
                          _c("b-icon", { attrs: { icon: "plus-circle" } }),
                          _vm._v(" Add Payment "),
                          _vm.loading ? _c("b-spinner") : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-modal",
        {
          ref: "viewSignatureModalOpen",
          attrs: {
            title: "View Signature",
            "hide-footer": "",
            centered: "",
            width: "100%",
            height: "30vh",
          },
        },
        [
          _c("b-card", { staticClass: "text-center m-1" }, [
            _c("img", {
              staticClass: "img-fluid",
              staticStyle: {
                border: "1px solid #ccc",
                "background-color": "#fff",
                "max-height": "30vh",
                "object-fit": "contain",
              },
              attrs: { src: _vm.signatureData, alt: "Digital Signature" },
            }),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }